import { Breadcrumb, Card } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { ReactComponent as TitleIcon } from "../../../assests/images/settingsBreadCum.svg";
import { ReactComponent as DebitCardIcon } from "../../../assests/images/DebitCard.svg";
import { ReactComponent as ChequeBookIcon } from "../../../assests/images/cheque_book_request.svg";
import { ReactComponent as ChequeStatusIcon } from "../../../assests/images/cheque_status.svg";
import { ReactComponent as StopChequeIcon } from "../../../assests/images/stop_cheque.svg";
import AccountCard from "../../../components/account-card";
import { ReactComponent as EStatementRequestIcon } from "../../../assests/images/estatementreq.svg";
import { ReactComponent as RequestIcon } from "../../../assests/images/request.svg";
import { ReactComponent as HomeIcon } from "../../../assests/images/home-line.svg";

export default function Request() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <>
        {/* <Breadcrumb separator=">">
          <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span onClick={() => navigate("/settings")}>
              {t("navigation.other", {
                defaultValue: "Other Services",
              })}
            </span>
          </Breadcrumb.Item> 
          <Breadcrumb.Item>
            <span>
              {t("pages.my_accounts.cardless_cash.request", {
                defaultValue: "Service Request",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb> */}

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {t("pages.my_accounts.cardless_cash.request", {
                defaultValue: "Request",
              })}
            </h3>
          </div>
        </div>
      </Card>
      <div className="row d-flex justify-content-between">
        <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 hide-xs">
          <Card className="application-card"  >
            <AccountCard />
          </Card>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
          <Card className="application-card ">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <Card
                  className="settingscard mb-3 "
                  align="center"
                  onClick={() =>
                    navigate("/request/cheque-book/request-cheque")
                  }
                >
                  <div className="mb-3">
                    <ChequeBookIcon height={35} width={35} />
                  </div>
                  <div className="my-2">
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      {t("pages.settings.order_cheque", {
                        defaultValue: "Order Cheque Book",
                      })}
                    </span>
                  </div>
                  <div>
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      {t("pages.settings.order_new_chque", {
                        defaultValue: "Order New Cheque book",
                      })}
                    </span>
                  </div>
                </Card>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <Card
                  className="settingscard mb-3 "
                  align="center"
                  onClick={() => navigate("/standing-instruction")}
                >
                  <div className="mb-3">
                    <RequestIcon height={35} />
                  </div>
                  <div className="my-2">
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      {t("pages.settings.si", {
                        defaultValue: "Standing Order",
                      })}
                    </span>
                  </div>
                  <div>
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      {t("pages.settings.si_title_desc", {
                        defaultValue: "Create and view standard instruction",
                      })}
                    </span>
                  </div>
                </Card>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <Card
                  className="settingscard mb-3 "
                  align="center"
                  onClick={() => navigate("/request/cheque-status")}
                >
                  <div className="mb-3">
                    <ChequeStatusIcon height={35} width={35} />
                  </div>
                  <div className="my-2">
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      {t("pages.cheques.cheque_status", {
                        defaultValue: "Cheque Status",
                      })}
                    </span>
                  </div>
                  <div>
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      {t("pages.cheques.cheque_check_status", {
                        defaultValue: " Check Cheque Status",
                      })}
                    </span>
                  </div>
                </Card>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <Card
                  className="settingscard mb-3 "
                  align="center"
                  onClick={() => navigate("/request/stop-cheque")}
                >
                  <div className="mb-3">
                    <StopChequeIcon height={35} width={35} />
                  </div>
                  <div className="my-2">
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      {t("pages.cheques.stop_cheque", {
                        defaultValue: "Stop Cheque",
                      })}
                    </span>
                  </div>
                  <div>
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      {t("pages.cheques.stop_cheque_request", {
                        defaultValue: "Stop Cheque Request",
                      })}
                    </span>
                  </div>
                </Card>
              </div>


              {/* <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <Card
                  className="settingscard mb-3 "
                  align="center"
                  onClick={() => navigate("/request/eStatement")}
                >
                  <div className="my-3">
                    <EStatementRequestIcon height={40} />
                  </div>
                  <div className="my-2">
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      {t("pages.my_accounts.casa.eStatement_Request", {
                        defaultValue: "eStatement Request",
                      })}
                    </span>
                  </div>
                  <div>
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      {t("pages.settings.req_desc", {
                        defaultValue: "Request, Update and Stop eStatement",
                      })}
                    </span>
                  </div>
                </Card>
              </div> */}

              {/*<div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <Card
                  className="settingscard mb-3 "
                  align="center"
                  onClick={() => navigate("/cardless-cash")}
                >
                  <div className="mb-3">
                  <RequestIcon height={35} />
                  </div>
                  <div className="my-2">
                    <span
                    className="secondary_txt_color_two"
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      {t("pages.my_accounts.cardless_cash.cardless_cash", {
                defaultValue: "Cardless Cash",
              })}
                    </span>
                  </div>
                  <div>
                    <span
                    className="secondary_txt_color_two"
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      Generate and View Cardless Cash
                    </span>
                  </div>
                </Card>
                    </div>*/}
              {/* <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <Card
                  className="settingscard mb-3 "
                  align="center"
                  onClick={() => navigate("/request/debit-card")}
                >
                  <div className="my-3">
                    <DebitCardIcon height={40} />
                  </div>
                  <div className="my-2">
                    <span
                    classNmae="secondary_txt_color_two"
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                   { t("pages.profile.debit_card", {
                          defaultValue: "Debit Card",
                        })}   
                    </span>
                  </div>
                  <div>
                    <span
                    className="secondary_txt_color_two"
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      Request, block and Re Issue Debit Card
                    </span>
                  </div>
                </Card>
              </div> */}
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}
